// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCrLYb2iA8b-wdKjQLsGWydlTIxKplN3D0",
  authDomain: "peppolvatverifier.firebaseapp.com",
  projectId: "peppolvatverifier",
  storageBucket: "peppolvatverifier.firebasestorage.app",
  messagingSenderId: "281397953553",
  appId: "1:281397953553:web:d93a902ffbdca955c6ddb0",
  measurementId: "G-L7BM87KGG1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Analytics (optional)
export const analytics = getAnalytics(app);

export default app;
